import { Navigate, Route, Routes } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import Home from "./Components/Home/Home";
import Footer from "./Components/Footer/Footer";
import About from "./Pages/About/About";
import Clients from "./Pages/Clients/Clients";
import Contact from "./Pages/Contact/Contact";
import Institutions from "./Pages/Institutions/Institutions";
import Partners from "./Pages/Partners/Partners";
import BacktoTop from "./Commons/BacktoTop/BacktoTop";
import Privacypolicy from "./Pages/Privacypolicy/Privacypolicy";
import Processingfees from "./Pages/Processingfees/Processingfees";
import Termsandconditions from "./Pages/Termsandconditions/Termsandconditions";
import Leadership from "./Pages/Leadership/Leadership";
import Career from "./Pages/Career/Career";
import Refundpolicy from "./Pages/Refundpolicy/Refundpolicy";
import "./responsive.css";
function App() {
  return (
    <>
      <Navbar />
      <main id="main-content" tabIndex="-1">
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Clients" element={<Clients />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Institutions" element={<Institutions />} />
        <Route path="/Partners" element={<Partners />} />
        <Route path="/Privacypolicy" element={<Privacypolicy />} />
        <Route path="/Processingfees" element={<Processingfees />} />
        <Route path="/Termsandconditions" element={<Termsandconditions />} />
        <Route path="/Leadership" element={<Leadership />} />
        <Route path="/Careers" element={<Career />} />
        <Route path="/Consultationfee" element={<Refundpolicy />} />
        <Route path="/Resumeform" element={<Navigate to="/Contact" replace />} />
      </Routes>
      </main>
      <BacktoTop />

      <Footer />
    </>
  );
}

export default App;


